/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/stocks_medium'
export default icon
